module.exports = __webpack_public_path__ + "static/media/selectedTrainStopIcon.525bbbfa.png";